import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';

class LodingSquareTabbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: '',
      initialToggle: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading && this.state.initialToggle) {
      this.setState({ initialToggle: false });
    }
  }

  componentDidUpdate() {
    if (!this.state.initialToggle && !this.props.loading) {
      this.setState({ currentPage: this.props.list[0], initialToggle: true }, function() {
        this.toggleClasses(this.props.list[0]);
      });
    }
  }

  componentDidMount() {
    if (!this.state.initialToggle && !this.props.loading) {
      this.setState({ currentPage: this.props.list[0], initialToggle: true }, function() {
        this.toggleClasses(this.props.list[0]);
      });
    }
  }

  toggleClasses(id) {
    const tabs = this.props.list;
    const currentPage = this.state.currentPage;

    // Remove the class from the previously active tab
    if (currentPage !== id) {
      const prevTab = document.getElementById(currentPage);
      if (prevTab) {
        prevTab.classList.remove('text-blue-600');
        prevTab.classList.remove('border-blue-500');
        prevTab.classList.remove('bg-white');
      }
    }

    // Apply the class to the clicked tab
    const currentTab = document.getElementById(id);
    if (currentTab) {
      currentTab.classList.add('text-blue-600');
      currentTab.classList.add('border-blue-500');
      currentTab.classList.add('bg-white');
    }
  }

  handler = (event) => {
    const id = event.target.id;
    this.toggleClasses(id);
    this.setState({ currentPage: id });
    this.props.handler(event.target.innerText);
  };

  render() {
    return (
      <div className={this.props.classes}>
        <div>
          <nav className='-mb-px flex w-1/2' aria-label='Tabs'>
            {this.props.list.map((item) => {
              return this.props.loading ? (
                <div key={item} className='w-20 mr-2'>
                  <Skeleton width='100%' height={this.props.loaderHeight} />
                </div>
              ) : (
                <span
                  key={item}
                  onClick={this.handler}
                  id={item}
                  className='border border-sm bg-gray-100 border-gray-300 text-gray-700 mr-1 rounded-md py-2 px-4 font-semibold hover:border-blue-500 hover:border-lg hover:text-blue-600 cursor-pointer'
                >
                  {item}
                </span>
              );
            })}
          </nav>
        </div>
      </div>
    );
  }
}

LodingSquareTabbar.defaultProps = {
  classes: '',
};

export default LodingSquareTabbar;
